/* PDP only (loaded by sections/main-product.liquid): keeps the "Measurement guide" link next to the SIZE label.
   The size chart app puts its link into the label once; when the swatch app redraws the size row (after a colour is chosen)
   the link is lost, so the very same element (its click handler stays) is put back into the new label. */
(function () {
  if (!document.body.classList.contains('product')) return;

  var saved = null;
  var queued = false;

  function check() {
    queued = false;
    var group = document.querySelector('product-info:not(quick-add-modal product-info) [option-name="Size"]');
    if (!group) return;

    var present = group.querySelector('.ks-chart-container');
    if (present) {
      saved = present;
      return;
    }

    var label = group.querySelector('label.swatch-label');
    if (saved && label) label.appendChild(saved);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }

  function init() {
    var info = document.querySelector('product-info:not(quick-add-modal product-info)');
    if (!info) return;
    new MutationObserver(queue).observe(info, { childList: true, subtree: true });
    queue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
